import { IScan } from "../../../models/dashboard";
import {
    LineChart as RechartLineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip as RechartToolTip,
    Legend,
  } from "recharts";
import moment from "moment";
import Tooltip from "../Tooltip/Tooltip";
import useWindowDimensions from "../../../hooks/UseWindowDimensions";
import useDashboardSelection from "../../../hooks/UseDashboardSelection";
import Spinner from "../../Spinner/Spinner";
import { Stack } from "@mui/material";
import SingleDateSelect from "../../DateSelection/SingleDateSelection/SingleDateSelect";
import BuildingSelect from "../../BuildingSelection/BuildingSelect";


const dateFormatter = (date: Date) => {
    return moment(date).format("DD MMM, h:mma");
};

const colors = ["#d45087","#003f5c","#ffa600","#a05195","#f95d6a","#ff7c43"];
const getRandomColor = (id : number) => {         
    return colors[id % colors.length];
};

const LineChart = () => {
    const data : Map<string,any[]> = new Map<string,any[]>();
    const dateGetter = (scan : IScan) =>  moment(scan.date).local().toDate();
    const {start,setStart,setEnd,buildingId,setBuildingId,buildings,buildingSelections,isLoading} = 
    useDashboardSelection(
        moment().startOf('day').toDate(),
        moment().endOf('day').toDate()
    );


    buildings.forEach(building => {
        let floor = parseInt(building.floor);
        building.locals.forEach( local => {
            local.scans.forEach(scan => {
                let userName = scan.username;
                let datum= {[userName] : floor,date : dateGetter(scan)};
                data.has(userName) ? data.get(userName)?.push(datum) : data.set(userName, [datum])
            });
        })
    })
    const series = Array.from(data.keys()).map( (userName, i) => ({
        id : i,
        label : userName,
        data : (data.get(userName) as any[]).sort((a,b) => a.date.getTime()-b.date.getTime())
    }))
    const { height, width } = useWindowDimensions();

    return (
        <>
            <header>
                <Stack direction="row" spacing={2}>
                    <SingleDateSelect
                        setEnd={setEnd}
                        setStart={setStart}
                        start={start} />
                    <BuildingSelect
                        buildingId={buildingId} 
                        buildingSelections={buildingSelections}
                        setBuildingId={setBuildingId} />
                </Stack>
            </header>
            
            {
                isLoading ? <Spinner/> :
                series.length ?
                <RechartLineChart
                    width={width > 300 ? width - 100 : width}
                    height={height/2}
                    margin={{top: 5,right: 30,left: 20,bottom: 5}}
                >
                    <CartesianGrid strokeDasharray="10 10" />
                    <XAxis dataKey="date" tickFormatter={dateFormatter}  interval={'preserveStart'}/>
                    <YAxis interval={'preserveStartEnd'}/>
                    <RechartToolTip content={<Tooltip />} />
                    <Legend />
                    {series.map(s => 
                        <Line
                            type="stepAfter"
                            dataKey={s.label}
                            data={s.data}
                            name = {s.label}
                            key = {s.label}
                            stroke={getRandomColor(s.id)}
                            activeDot={{ r: 6 }}
                            strokeWidth={2}
                        />
                    )}
                </RechartLineChart> : <div>No data for selected date</div>
            }
        </>
    );
}
export default LineChart;

